import { IconAlertTriangle } from '@iwoca/icons';
import { Button } from '@iwoca/orion';

import {
  useSuspenseGetBuyerSpendingLimitRequest,
  useSuspenseGetFormalOffers,
} from '../../../../api/lending/lapiHooks.suspense';

const goToSecurityCheck = (offerId?: string) => {
  const queryParams = new URLSearchParams(window.location.search);

  if (offerId) {
    queryParams.append('offerId', offerId);
  }

  const query = queryParams.toString();
  window.location.href = `/pay/security-checks/${query ? `?${query}` : ''}`;
};

export const SLSecurityCheckBanner = () => {
  const { spendingLimitRequest } = useSuspenseGetBuyerSpendingLimitRequest();
  const { formalOffers } = useSuspenseGetFormalOffers();

  if (!spendingLimitRequest?.data?.uuid) return null;

  const firstIwocapayOffer = formalOffers?.formal_offers?.find(
    (offer) => offer.product_type === 'iwocapay',
  );

  return (
    <section className="mb-l flex flex-col gap-l rounded-s border border-warning bg-structure-100 p-l">
      <div className="flex flex-col gap-m">
        <div className="flex items-start gap-s">
          <IconAlertTriangle className="mt-2xs h-[24px] w-[24px] shrink-0 fill-[#FFB200]" />
          <div>
            <h2 className="m-0 text-l font-bold">
              You'll need to do some security checks before using your spending
              limit
            </h2>
          </div>
        </div>
        <div>
          <p className="m-0 text-m font-reg text-structure-20">
            You can do them now, or when you're making your first purchase using
            iwocaPay.
          </p>
        </div>
      </div>
      <Button
        variant="primary"
        onClick={() => goToSecurityCheck(firstIwocapayOffer?.offer_id)}
      >
        Finish security checks
      </Button>
    </section>
  );
};
